import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-corner",
  "use": "icon-corner-usage",
  "viewBox": "0 0 5 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 5\" id=\"icon-corner\"><path d=\"M88-21V0a4.999 4.999 0 0 0 4.783 4.995L93 5H0A4.999 4.999 0 0 0 4.995.217L5 0v-21a5 5 0 0 1 5-5h73a5 5 0 0 1 5 5z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol